var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-popover',_vm._b({},'b-popover',_vm.$props,false),[_vm._t("title",null,{"slot":"title"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }